import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC } from 'react';

type RowTextType = {
  text:string
}

const useStyles = makeStyles(() => ({
  textStyle: { fontWeight: 500, textTransform: 'none' }
}));

const RowText: FC <RowTextType> = ({ text }) => {
  const classes = useStyles();
  return (
    <Typography
      noWrap
      variant="body2"
      className={classes.textStyle}
    >
      {text}
    </Typography>
  );
};

export default RowText;
